// extracted by css-extract-rspack-plugin
export default {"docsLink":"QEn9n"};